module.exports = __webpack_public_path__ + "officialStatic/img/wx-spec-zhuanqian.a8ae5cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/wx-spec-zhuanqian.png
// module id = muqp
// module chunks = 0